import { initScrollClasses, initModal } from "./functions/core";
import {
  initDatalayer,
  readCookiePermissions,
  readCookie,
  initCookiesBox,
} from "./functions/cookies";
import {
  validateFormBootstrap,
  initCustomFileInputs,
  recaptchaData,
} from "./functions/forms";

import Alert from "bootstrap/js/dist/alert";
import Button from "bootstrap/js/dist/button";
import Carousel from "bootstrap/js/dist/carousel"; // Use Swiper instead
import Collapse from "bootstrap/js/dist/collapse";
import Dropdown from "bootstrap/js/dist/dropdown";
import Modal from "bootstrap/js/dist/modal";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import Popover from "bootstrap/js/dist/popover"; // Requires Popper.js
import ScrollSpy from "bootstrap/js/dist/scrollspy";
import Tab from "bootstrap/js/dist/tab";
import Toast from "bootstrap/js/dist/toast";
import Tooltip from "bootstrap/js/dist/tooltip"; // Requires Popper.js

import { initSwiper } from "./functions/optional/swiper";
import { initSelect2 } from "./functions/optional/select2";
import { initDatepicker } from "./functions/optional/datepicker";
import { toggleCollapseOnParent } from "./functions/optional/parent-collapse";
// Add functions to the global window object to give access to backend devs

// Add functions to the global window object to give access to backend devs

document.addEventListener("DOMContentLoaded", function () {
  console.log("Developed by LOBA - https://www.loba.com/");

  //=== Core ===//

  initScrollClasses(".header");
  window.initModal = initModal;

  //=== Optional ===//

  initSwiper(".swiper-from-dataset");
  window.initSwiper = initSwiper;

  initSelect2(".custom-select-option select");
  window.initSelect2 = initSelect2;

  initDatepicker(".datepicker-input");
  window.initDatepicker = initDatepicker;

  initCustomFileInputs(".custom-file input");
  window.initCustomFileInputs = initCustomFileInputs;

  toggleCollapseOnParent();

  //=== Cookies ===//

  initDatalayer();
  readCookiePermissions("loba_");
  window.readCookie = readCookie;
  window.initCookiesBox = initCookiesBox;

  //=== Forms ===//

  validateFormBootstrap(".needs-validation");
  window.recaptchaData = recaptchaData;
  window.initCustomFileInputs = initCustomFileInputs;

  //=== Bootstrap ===//

  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(function (tooltip) {
      new Tooltip(tooltip);
    });

  document
    .querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(function (popover) {
      new Popover(popover);
    });

  //SELECT EQUIPAMENTOS
  const equipmentsList = document.querySelector(".equipments");
  if (equipmentsList) {
    $("#select-categoria").on("change", function () {
      $(".select2-selection__rendered").prepend("<span>Categoria: </span>");
    });
    $(".select2-selection__rendered").prepend("<span>Categoria: </span>");

    /********************* TIPO DE VISTA********************/
    $(".list-view").hide();
    $(".filter-btn button").on("click", function (e) {
      e.preventDefault();

      var $this = $(this);
      var shopProductWrap = $(".equipamentos-container");
      var viewMode = $this.data("target");

      $(".filter-btn button").removeClass("active");
      $this.addClass("active");
      shopProductWrap.removeClass("grid list").addClass(viewMode);

      if ($(".equipamentos-container").hasClass("list")) {
        $(".grid-view").hide();
        $(".list-view").fadeIn("slow");
      } else {
        $(".list-view").hide();
        $(".grid-view").fadeIn("slow");
      }
    });
  }

  const newsContainer = document.querySelector(".news");
  if (newsContainer) {
    /********************* TIPO DE VISTA********************/
    $(".list-view").hide();
    $(".filter-btn button").on("click", function (e) {
      e.preventDefault();

      var $this = $(this);
      var shopProductWrap = $(".news-container");
      var viewMode = $this.data("target");

      $(".filter-btn button").removeClass("active");
      $this.addClass("active");
      shopProductWrap.removeClass("grid list").addClass(viewMode);

      if ($(".news-container").hasClass("list")) {
        $(".grid-view").hide();
        $(".list-view").fadeIn("slow");
      } else {
        $(".list-view").hide();
        $(".grid-view").fadeIn("slow");
      }
    });
  }
  // CONTENTOR HEADER PESQUISA
  $(".pesquisa-container").hide();
  $(".btn-pesquisa").click(function () {
    $(".pesquisa-container").slideToggle();
  });

  $(".srchtxt").click(function () {
    $(".pesquisa-container").animate({ height: "100vh" });
  });
  $(".close-search").click(function () {
    $(".pesquisa-container").slideToggle();
    $(".pesquisa-container").css("height", "16rem");
  });

  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data("field");
    var parent = $(e.target).closest("div");
    var currentVal = parseInt(
      parent.find("input[name=" + fieldName + "]").val(),
      10
    );

    if (!isNaN(currentVal)) {
      parent.find("input[name=" + fieldName + "]").val(currentVal + 1);
    } else {
      parent.find("input[name=" + fieldName + "]").val(0);
    }
  }

  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data("field");
    var parent = $(e.target).closest("div");
    var currentVal = parseInt(
      parent.find("input[name=" + fieldName + "]").val(),
      10
    );

    if (!isNaN(currentVal) && currentVal > 0) {
      parent.find("input[name=" + fieldName + "]").val(currentVal - 1);
    } else {
      parent.find("input[name=" + fieldName + "]").val(0);
    }
  }

  $(".input-group").on("click", ".button-plus", function (e) {
    incrementValue(e);
  });

  $(".input-group").on("click", ".button-minus", function (e) {
    decrementValue(e);
  });

  $(".change-password-container").hide();
  $(".change-password").on("click", function () {
    $(".change-password-container").addClass("show");

    if ($(".change-password-container").hasClass("show")) {
      $(".change-password-container").fadeIn("show");
      $(".change-password").hide();
    }
  });
  $(".right-container").on("click", function () {
    $(".change-password-container").removeClass("show");

    $(".change-password-container").fadeOut("show");
    $(".change-password").fadeIn();
  });

  $(".accordion-header").click(function () {
    if (
      $(".accordion-collapse").hasClass("collapsing") ||
      $(".accordion-collapse").hasClass("show")
    ) {
      $(this).parent().toggleClass("color-title");
      $(this).find("svg").toggleClass("rotate");
    }
  });

  $(".um_input_de_texto_do_form").on("keyup", function () {
    if (!$(this).val()) {
      $(this).removeClass("filled");
    } else {
      $(this).addClass("filled");
    }
  });

  if (window.location.href.includes("account-address")) {
    $(".account-addresses button").toggleClass("color");
    $(".account-addresses .accordion-collapse").addClass("collapse");
    $(".account-addresses .accordion-collapse").addClass("show");
    $(".account-addresses .accordion-collapse .products").addClass("color");
    $(".account-addresses .accordion-collapse .bulk").removeClass("color");
    $(".account-addresses .accordion-collapse .piped").removeClass("color");
    $(".account-addresses svg").addClass("rotate");
    $(".account-addresses").addClass("color-title");
  }
  if (window.location.href.includes("account-checking")) {
    $(".account-checking button").addClass("color");
    $(".account-checking .accordion-collapse").addClass("collapse");
    $(".account-checking .accordion-collapse").addClass("show");
    $(".account-checking .accordion-collapse .products").addClass("color");
    $(".account-checking .accordion-collapse .bulk").removeClass("color");
    $(".account-checking .accordion-collapse .piped").removeClass("color");
    $(".account-checking svg").addClass("rotate");
    $(".account-checking").addClass("color-title");
  }
  if (window.location.href.includes("account-orders")) {
    $(".account-orders button").addClass("color");
    $(".account-orders .accordion-collapse").addClass("collapse");
    $(".account-orders .accordion-collapse").addClass("show");
    $(".account-orders .accordion-collapse .products").addClass("color");
    $(".account-orders .accordion-collapse .bulk").removeClass("color");
    $(".account-orders .accordion-collapse .piped").removeClass("color");
    $(".account-orders svg").addClass("rotate");
    $(".account-orders").addClass("color-title");    
  }
  if (window.location.href.includes("account-recommendations")) {
    $(".account-recommendations button").addClass("color");
    $(".account-recommendations .accordion-collapse").addClass("collapse");
    $(".account-recommendations .accordion-collapse").addClass("show");
    $(".account-recommendations .accordion-collapse .gas-em-garrafa").addClass(
      "color"
    );
    $(
      ".account-recommendations .accordion-collapse .gas-canalizado"
    ).removeClass("color");
    $(".account-recommendations .accordion-collapse .gas-a-granel").removeClass(
      "color"
    );
    $(".account-recommendations svg").addClass("rotate");
    $(".account-recommendations").addClass("color-title");
  }

  $(".accordion-header").click(function () {
    if (
      $(".accordion-collapse").hasClass("collapsing") ||
      $(".accordion-collapse").hasClass("show")
    ) {
      $(this).parent().toggleClass("color-title");
      $(this).find("svg").toggleClass("rotate");
    }
  });

  $(".contrato").on("change", function () {
    $(".contrato .select2-selection__rendered").prepend(
      "<span>Cliente: </span>"
    );
  });
  $(".contrato .select2-selection__rendered").prepend("<span>Cliente: </span>");

  $(".tipo select").on("change", function () {
    $(".tipo .select2-selection__rendered").prepend(
      "<span>Tipologias: </span>"
    );
  });
  $(".tipo .select2-selection__rendered").prepend("<span>Tipologias: </span>");

  $(".ano select").on("change", function () {
    $(".ano .select2-selection__rendered").prepend(
      "<span>Ano selecionado: </span>"
    );
  });
  $(".ano .select2-selection__rendered").prepend(
    "<span>Ano selecionado: </span>"
  );

  function limpar_moradas_de_entrega() {
    let slides = document.getElementsByClassName(
      "botao_de_uma_morada_de_entrega"
    );
    for (let i = 0; i < slides.length; i++) {
      slides.item(i).classList.remove("ativado");
      slides.item(i).classList.remove("active");
    }
  }

  let botoes_moradas_entrega = document.getElementsByClassName(
    "botao_de_uma_morada_de_entrega"
  );
  for (let i = 0; i < botoes_moradas_entrega.length; i++) {
    botoes_moradas_entrega.item(i).addEventListener("click", function (event) {
      limpar_moradas_de_entrega();
      botoes_moradas_entrega.item(i).classList.add("ativado");
      botoes_moradas_entrega.item(i).classList.add("active");
    });
  }

  limpar_moradas_de_entrega();

  //function ativar_entrega_ao_domicilio() {
  const botao_ativar_entrega_ao_domicilio = document.querySelector(
    ".botao_ativar_entrega_ao_domicilio "
  );
  const botao_ativar_entrega_em_loja = document.querySelector(
    ".botao_ativar_entrega_em_loja "
  );
  if (botao_ativar_entrega_ao_domicilio && botao_ativar_entrega_em_loja) {
    botao_ativar_entrega_ao_domicilio.addEventListener("click", function () {
      document.querySelector(".loja").classList.add("d-none");
      document.querySelector(".domicilio-container").classList.remove("d-none");
      document
        .querySelector(".botao_ativar_entrega_ao_domicilio")
        .classList.add("ativado");
      document
        .querySelector(".botao_ativar_entrega_em_loja")
        .classList.remove("ativado");
    });

    //}

    botao_ativar_entrega_em_loja.addEventListener("click", function () {
      //function ativar_entrega_em_loja() {
      document.querySelector(".loja").classList.remove("d-none");
      document.querySelector(".domicilio-container").classList.add("d-none");
      document
        .querySelector(".botao_ativar_entrega_ao_domicilio")
        .classList.remove("ativado");
      document
        .querySelector(".botao_ativar_entrega_em_loja")
        .classList.add("ativado");
    });
  }

  function limpar_lojas() {
    let slides = document.getElementsByClassName("botao_de_uma_loja");
    for (let i = 0; i < slides.length; i++) {
      slides.item(i).classList.remove("ativado");
      slides.item(i).classList.remove("active");
      //Distribute(slides.item(i));
    }
  }

  let botoes_lojas = document.getElementsByClassName("botao_de_uma_loja");
  for (let i = 0; i < botoes_lojas.length; i++) {
    botoes_lojas.item(i).addEventListener("click", function (event) {
      //plusDivs(-1);
      //document.getElementById(event.target.id).classList.add('ativado');
      //console.log(event);
      limpar_lojas();
      botoes_lojas.item(i).classList.add("ativado");
      botoes_lojas.item(i).classList.add("active");
    });
    //Distribute(slides.item(i));
  }

  limpar_lojas();

  const emptyTrue = document.getElementById("emptyTrue");
  const emptyFalse = document.getElementById("#emptyFalse");
  if (emptyTrue || emptyFalse) {
    if (
      document.querySelector("#emptyTrue").checked ||
      document.querySelector("#emptyFalse").checked
    ) {
      document
        .querySelector("#botao_de_encomendar_isto")
        .classList.remove("d-none");
    }

    if (!document.querySelector("#emptyTrue").checked) {
      $(".allBottlesToExchenge").hide();
    }

    function showPanelBottles() {
      $(".allBottlesToExchenge").fadeIn("slow");
      document
        .querySelector("#botao_de_encomendar_isto")
        .classList.remove("d-none");
    }
    function hidePanelBottles() {
      $(".allBottlesToExchenge").fadeOut("slow");
      document
        .querySelector("#botao_de_encomendar_isto")
        .classList.remove("d-none");
    }

    document.querySelector("#emptyTrue").addEventListener("click", function () {
      if (document.querySelector("#emptyTrue").checked) {
        showPanelBottles();
      } else {
        hidePanelBottles();
      }
    });
    document
      .querySelector("#emptyFalse")
      .addEventListener("click", function () {
        if (document.querySelector("#emptyFalse").checked) {
          hidePanelBottles();
        } else {
          showPanelBottles();
        }
      });
  }

  $("#ul-cookies li")
    .mouseenter(function () {
      $(this).addClass("hover-cookie");
    })
    .mouseleave(function () {
      $(this).removeClass("hover-cookie");
    });

  $(".privacidade").click(function () {
    $("#privacidade").fadeIn();
    $(".privacidade").addClass("cookie-visivel");
    $("#necessarios").hide();
    $("#preferencias").hide();
    $("#estatisticos").hide();
    $("#marketing").hide();
    $("#seguranca").hide();
    $("#personalizacao").hide();

    $(".necessarios").removeClass("cookie-visivel");
    $(".preferencias").removeClass("cookie-visivel");
    $(".estatisticos").removeClass("cookie-visivel");
    $(".marketing").removeClass("cookie-visivel");
    $(".seguranca").removeClass("cookie-visivel");
    $(".personalizacao").removeClass("cookie-visivel");
  });
  $(".necessarios").click(function () {
    $("#necessarios").fadeIn();
    $(".necessarios").addClass("cookie-visivel");
    $("#privacidade").hide();
    $("#preferencias").hide();
    $("#estatisticos").hide();
    $("#marketing").hide();
    $("#seguranca").hide();
    $("#personalizacao").hide();

    $(".privacidade").removeClass("cookie-visivel");
    $(".preferencias").removeClass("cookie-visivel");
    $(".estatisticos").removeClass("cookie-visivel");
    $(".marketing").removeClass("cookie-visivel");
    $(".seguranca").removeClass("cookie-visivel");
    $(".personalizacao").removeClass("cookie-visivel");
  });
  $(".preferencias").click(function () {
    $("#preferencias").fadeIn();
    $(".preferencias").addClass("cookie-visivel");
    $("#privacidade").hide();
    $("#necessarios").hide();
    $("#estatisticos").hide();
    $("#marketing").hide();
    $("#seguranca").hide();
    $("#personalizacao").hide();

    $(".privacidade").removeClass("cookie-visivel");
    $(".necessarios").removeClass("cookie-visivel");
    $(".estatisticos").removeClass("cookie-visivel");
    $(".marketing").removeClass("cookie-visivel");
    $(".seguranca").removeClass("cookie-visivel");
    $(".personalizacao").removeClass("cookie-visivel");
  });
  $(".estatisticos").click(function () {
    $("#estatisticos").fadeIn();
    $(".estatisticos").addClass("cookie-visivel");
    $("#privacidade").hide();
    $("#necessarios").hide();
    $("#preferencias").hide();
    $("#marketing").hide();
    $("#seguranca").hide();
    $("#personalizacao").hide();

    $(".privacidade").removeClass("cookie-visivel");
    $(".necessarios").removeClass("cookie-visivel");
    $(".preferencias").removeClass("cookie-visivel");
    $(".marketing").removeClass("cookie-visivel");
    $(".seguranca").removeClass("cookie-visivel");
    $(".personalizacao").removeClass("cookie-visivel");
  });
  $(".marketing").click(function () {
    $("#marketing").fadeIn();
    $(".marketing").addClass("cookie-visivel");
    $("#privacidade").hide();
    $("#necessarios").hide();
    $("#preferencias").hide();
    $("#estatisticos").hide();
    $("#seguranca").hide();
    $("#personalizacao").hide();

    $(".privacidade").removeClass("cookie-visivel");
    $(".necessarios").removeClass("cookie-visivel");
    $(".preferencias").removeClass("cookie-visivel");
    $(".estatisticos").removeClass("cookie-visivel");
    $(".seguranca").removeClass("cookie-visivel");
    $(".personalizacao").removeClass("cookie-visivel");
  });
  $(".seguranca").click(function () {
    $("#seguranca").fadeIn();
    $(".seguranca").addClass("cookie-visivel");
    $("#privacidade").hide();
    $("#necessarios").hide();
    $("#preferencias").hide();
    $("#estatisticos").hide();
    $("#marketing").hide();
    $("#personalizacao").hide();

    $(".privacidade").removeClass("cookie-visivel");
    $(".necessarios").removeClass("cookie-visivel");
    $(".preferencias").removeClass("cookie-visivel");
    $(".estatisticos").removeClass("cookie-visivel");
    $(".marketing").removeClass("cookie-visivel");
    $(".personalizacao").removeClass("cookie-visivel");
  });
  $(".personalizacao").click(function () {
    $("#personalizacao").fadeIn();
    $(".personalizacao").addClass("cookie-visivel");
    $("#privacidade").hide();
    $("#necessarios").hide();
    $("#preferencias").hide();
    $("#estatisticos").hide();
    $("#marketing").hide();
    $("#seguranca").hide();

    $(".privacidade").removeClass("cookie-visivel");
    $(".necessarios").removeClass("cookie-visivel");
    $(".preferencias").removeClass("cookie-visivel");
    $(".estatisticos").removeClass("cookie-visivel");
    $(".marketing").removeClass("cookie-visivel");
    $(".seguranca").removeClass("cookie-visivel");
  });

  $("input#cookiePolicyCheck2").change(function () {
    $(this).toggleClass("desativado");
    if ($("input#cookiePolicyCheck2").hasClass("desativado")) {
      $(".ativado-preferencias").hide();
      $(".desativado-preferencias").show();
    } else {
      $(".desativado-preferencias").hide();
      $(".ativado-preferencias").show();
    }
  });

  $("input#cookiePolicyCheck3").change(function () {
    $(this).toggleClass("desativado");
    if ($("input#cookiePolicyCheck3").hasClass("desativado")) {
      $(".ativado-estatisticos").hide();
      $(".desativado-estatisticos").show();
    } else {
      $(".desativado-estatisticos").hide();
      $(".ativado-estatisticos").show();
    }
  });

  $("input#cookiePolicyCheck4").change(function () {
    $(this).toggleClass("desativado");
    if ($("input#cookiePolicyCheck4").hasClass("desativado")) {
      $(".ativado-marketing").hide();
      $(".desativado-marketing").show();
    } else {
      $(".desativado-marketing").hide();
      $(".ativado-marketing").show();
    }
  });

  $("input#cookiePolicyCheck5").change(function () {
    $(this).toggleClass("desativado");
    if ($("input#cookiePolicyCheck5").hasClass("desativado")) {
      $(".ativado-personalizacao").hide();
      $(".desativado-personalizacao").show();
    } else {
      $(".desativado-personalizacao").hide();
      $(".ativado-personalizacao").show();
    }
  });

  $("input#cookiePolicyCheck6").change(function () {
    $(this).toggleClass("desativado");
    if ($("input#cookiePolicyCheck6").hasClass("desativado")) {
      $(".ativado-seguranca").hide();
      $(".desativado-seguranca").show();
    } else {
      $(".desativado-seguranca").hide();
      $(".ativado-seguranca").show();
    }
  });

  $('.um_elemento_clicavel_do_mapa').click(function() {
		let query = $(this).attr('data-name');
		
	});

	$( ".um_elemento_clicavel_do_mapa" ).hover(
		function() {
			$( this ).addClass( "hover" );
		}, function() {
			$( this ).removeClass( "hover" );
		}
	);

  $('#selected-results-faro').hide();
  $('#selected-results-alportel').hide();
  $('#selected-results-loule').hide();
  $('.btn-close-responsive').click(function() {
		$('#selected-results').removeClass('active');
		
		$('#select-regiao').val($('#select-regiao option:eq(0)').val()).trigger('change'); // Selecionar o 1º elemento da lista
		
	});
  $( "#select-regiao" ).on( "change", function() {
		let query = this.value;		
    console.log(query);
		if (query)
			{
        if(query == 'Faro')
        {
          $('#selected-results-faro').show();
          $('#selected-results-alportel').hide();
          $('#selected-results-loule').hide();
        }
        else if(query == 'São Brás de Alportel')
        {
          $('#selected-results-faro').hide();
          $('#selected-results-alportel').show();
          $('#selected-results-loule').hide();
        }
        else if(query == 'Loulé')
        {
          $('#selected-results-faro').hide();
          $('#selected-results-alportel').hide();
          $('#selected-results-loule').show();
        }
        else {
          $('#selected-results-faro').hide();
          $('#selected-results-alportel').hide();
          $('#selected-results-loule').hide();
        }
			//fetch_customer_data_responsive(query);
			//$('#selected-results').addClass('active');
			}
		else
		{
			//$('#titleresponsive').html('');
			//$('#accordionFlushRegionsResponsive').html('');
			$('#selected-results').removeClass('active');
		}
	} );
  
});
